import React, {useEffect, useState} from "react";

const AnimatedLogo: React.FC<{ collapsed: boolean; loginPage: boolean }> = ({ collapsed, loginPage }) => {
    const [isLogoUp, setIsLogoUp] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsLogoUp((prev) => !prev); // Toggle between the two images
        }, 2000); // Switch every 2 seconds

        return () => clearInterval(interval); // Cleanup interval on unmount
    }, []);

    function getLoginPageSize(){
        if(loginPage) return "15vh";
        else if (collapsed) return 50;
        else return 35;
    }

    return (
        <div style={{
        position: 'relative',
        width: getLoginPageSize(),
        height: getLoginPageSize(),
        minWidth: getLoginPageSize(), // Ensure it doesn't collapse
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }}>
        <img
            src="/logo.png"
            alt="Logo"
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                opacity: isLogoUp ? 0 : 1,
                transition: 'opacity 0.5s',
                pointerEvents: 'none' // Makes clicks pass through
            }}
        />
        <img
            src="/logo_up.png"
            alt="Logo Alt"
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                opacity: isLogoUp ? 1 : 0,
                transition: 'opacity 0.5s',
                pointerEvents: 'none'
            }}
        />
    </div>
    );
};

export default AnimatedLogo;